<template>
    <rkm-modal
        ref="modal"
        title="Observação"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-form-textarea
                :validations="validations.observacao"
                label="Observação"
                v-model="model.observacao"
            />
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="reopenSolicitacao"
                color="primary"
                type="submit"
            >
                Salvar
            </rkm-button>
        </template>

    </rkm-modal>
</template>
<script>

// Mixin.
import { repository } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
     computed: {
        validations() {
            return {
                observacao: {
                    max: 300,
                    required: true,
                }
            }
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('manutencao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            id: null,
            observacao: null,
        },
        enums: { statusTipo}
    }),
    methods: {

        open(item) {

            this.model.id = item.id
            this.model.observacao = null
            this.$refs.modal.show()
        },
        reopenSolicitacao() {

            this.$refs.Form.validate()
                .then( validate => {

                    if (!validate) return

                    this.repositories.solicitacao.update(
                        this.model.id,
                        {
                            acao: 'finalizar',
                            status: this.enums.statusTipo.FINALIZADO,
                            observacao: this.model.observacao
                        }
                    )
                    .then(() => {
                        this.showSaveNotification('Solicitação finalizada com sucesso!')
                        this.$emit('refresh')
                        this.$refs.modal.hide()
                    })
                    .catch(this.handleError)

                })
        },
    },
    mixins: [ repository ],
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>